import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { poppins500, poppins600 } from 'theme/common.style';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Divider, MenuItem, SwipeableDrawer, Typography } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CheckListActionButton = ({
  sectionName,
  renderData,
  disabledCondition,
  open,
  setOpen,
}) => {
  return (
    <>
      <Button
        variant="outlined"
        sx={{
          ...poppins500,
          fontSize: '12px',
          color: '#112347',
          height: '30px',
          borderRadius: '6px',
          border: '1px solid #6C2AD2',
          textTransform: 'none',
        }}
        onClick={() => {
          setOpen(true);
        }}
        endIcon={<KeyboardArrowDownIcon fontSize="12px" />}
        disabled={disabledCondition}
      >
        Action
      </Button>

      <SwipeableDrawer
        anchor="bottom"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        PaperProps={{
          sx: {
            backgroundColor: '#3C3C3C',
            borderRadius: '8px 8px 0 0',
            maxHeight: 'auto',
            overflowY: 'auto',
          },
        }}
        style={{ zIndex: '100000' }}
      >
        <MenuItem
          disableRipple
          sx={{
            ...poppins500,
            fontSize: '16px',
            color: '#FFFFFF',
            justifyContent: 'center',
            textAlign: 'center',
            mt: '5px',
          }}
        >
          {sectionName}
        </MenuItem>
        <Divider sx={{ borderColor: '#767676' }} />
        <Typography>{renderData}</Typography>
        <Divider
          sx={{
            borderColor: '#767676',
            height: '4px',
            borderBottomWidth: '4px',
          }}
        />
        <MenuItem
          onClick={() => {
            setOpen(false);
          }}
          sx={{
            ...poppins600,
            fontSize: '20px',
            color: '#349BFA',
            width: '100%',
            justifyContent: 'center',
            padding: '22px 0',
          }}
        >
          Cancel
        </MenuItem>
      </SwipeableDrawer>
    </>
  );
};

export default CheckListActionButton;
